export default "assets/images/flags/es-053e9f07.svg";